import { getActivityFeedSettings } from '../service/getActivityFeedSettings';
import { setActivityFeedSettings } from '../actions/setActivityFeedSettings';
import loadActivityFeed from './loadActivityFeed';
import { trace } from 'owa-trace';

export default function loadActivityFeedSettings() {
    const activityFeedSettingPromise = getActivityFeedSettings();
    return activityFeedSettingPromise
        .then(value => {
            if (value && value[0].name == 'notification_settings') {
                try {
                    const setting = JSON.parse(value[0].value) as { [key: number]: boolean };
                    setActivityFeedSettings(setting);
                    loadActivityFeed();
                } catch {
                    trace.warn('Failed to parse Activity feed settings');
                }
            }
        })
        .catch(function (err) {
            trace.warn('Failed to load activity feed settings ' + err.message);
            // We should load activity feed with default options as the settings failed to load.
            loadActivityFeed();
        });
}
